import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  weatherAlertsContentWrapper: {
    flexDirection: 'row',
  },
});
